/**
 * Landing page human photos — all from Unsplash (free, images.unsplash.com).
 * IDs verified from Unsplash portrait search. No ID is reused across strip, screen, phone, or avatar.
 */
const U = (id: string, w = 400) =>
  `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=80`;

// Verified free Unsplash portrait IDs (from unsplash.com/s/photos/portrait)
// Strip: 24 unique
const STRIP_IDS = [
  '1534528741775-53994a69daeb',
  '1524504381990-5fc4e76b4715',
  '1531746020798-e6953c6e8e04',
  '1507003215839-924316e94c7d',
  '1494790108377-be9c29b29330',
  '1500648767791-00dcc994a43e',
  '1543269664-7e6d6ac0a073',
  '1529156069898-49953e39b3ac',
  '1560250097-0b93528c311a',
  '1519345182560-3f2917c472ef',
  '1573496359323-2ee205f2b531',
  '1517841905240-472988babdf9',
  '1531123897722-8f8988c2f8b9',
  '1506794778202-cad84cf45f1d',
  '1544005313-94ddf0286df2',
  '1529626455594-4ff0802cfb7e',
  '1526517780841-816963224261',
  '1492562080023-ab3db95bfbce',
  '1580489944761-15a19d654956',
  '1632765854612-9b02b6ec2b15',
  '1521119989659-a83eee488004',
  '1570158268183-d296b2892211',
  '1508214756982-2d1c2b3d4e5f',
];

// Screen demo grid: 6 unique (none from strip)
const SCREEN_IDS = [
  '1614204424926-196a80bf0be8',
  '1522075469751-3a6694fb2f61',
  '1438761681033-6461ffad8d80',
  '1581403341630-a6e0b9d2d257',
  '1506863530036-1efeddceb993',
  '1515023116939-473c524f9ec9',
];

// Phone grid: 8 unique (none from strip or screen)
const PHONE_IDS = [
  '1502823403499-6ccfcf4df1f7',
  '1519699047748-de8e457a634e',
  '1502684697942-419c2d275b81',
  '1517180102446-f3ece416fd19',
  '1502375275164-66f181c6e0b9',
  '1520813995818-7c2c934689c3',
  '1507591060144-4d524719a456',
  '1551836022-deb4988cc6c0',
];

// Avatar: 1 unique (not in strip, screen, or phone)
const AVATAR_ID = '1573497019940-1c0c3795f89d';

export const stripPhotos: string[] = STRIP_IDS.map((id) => U(id, 320));
export const screenDemoPhotos: string[] = SCREEN_IDS.map((id) => U(id, 280));
export const phoneGridPhotos: string[] = PHONE_IDS.map((id) => U(id, 200));
export const phoneAvatarPhoto = U(AVATAR_ID, 80);
